export default function escapeRegExp(input: string) {
  return `^${input.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&")}$`;
}
